<div class="icons-counter">
    <div class="icons-counter__inner" [ngStyle]="{'height': height}">

        <div class="icons-counter__layer -for-inactive">
            <div class="icons-counter__item -inactive" *ngFor="let item of inactiveCountArr; let i = index">
                <img class="icons-counter__icon" [ngClass]="{'-transparent': i < activeCountArr?.length}"
                    directive-image-preload (onLoaded)="handleImageLoaded($event)" [url]="imagesPath + iconInactive"
                    alt="counter" />
            </div>
        </div>

        <div class="icons-counter__layer -for-active">
            <div class="icons-counter__item -active" *ngFor="let item of activeCountArr">
                <img class="icons-counter__icon" (onLoaded)="handleImageLoaded($event)" directive-image-preload
                    [url]="imagesPath + iconActive" alt="counter" />
            </div>
        </div>

    </div>
</div>
